<template>
  <with-actions>
    <div class="form-inline ml-auto" slot="context-actions" v-if="can('write_customers')">
      <button class="btn btn-primary" @click="spin($event, create)" :disabled="!valid_invoice">
        {{ 'create' | t }} {{ this.invoice.doc_type | t }}
      </button>
    </div>
    <div class="card">
      <div class="card-body" v-if="customer">
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label>{{ 'Invoice for' | t }}</label>
              <input class="form-control" disabled="true" v-model="customer.name" />
            </div>
            <div class="form-group">
              <label>{{ 'currency' | t }}</label>
              <input class="form-control" disabled="true" v-model="customer.currency" />
            </div>
            <template v-if="can('write_credit_memos')">
              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <label>{{ 'invoice_type' | t }}</label>
                    <select class="form-control" v-model="invoice.doc_type">
                      <option value="invoice">{{ 'invoice' | t }}</option>
                      <option value="credit_memo">{{ 'credit_memo' | t }}</option>
                    </select>
                  </div>
                </div>
                <div class="col">
                  <div class="form-group" v-if="invoice.doc_type == 'credit_memo'">
                    <div class="row">
                      <div class="col" v-if="false">
                        <label>{{ 'search_invoice' | t }}</label>
                        <input class="form-control" v-model="invoice_search" />
                      </div>
                      <div class="col">
                        <label>{{ 'select_invoice' | t }}</label>
                        <select class="form-control" v-model="invoice.invoice">
                          <option v-for="invoice in invoices" :value="invoice">
                            {{ 'Id.' }} {{ invoice.id }} {{ ', No.' }} {{ invoice.invoice_no }}, {{ ', Sub Total.' }}
                            {{ invoice.sub_total_amount | currency }} {{ invoice.currency }} {{ ', Total Amount.' }}
                            {{ invoice.total_amount | currency }} {{ invoice.currency }} {{ ', Date.' }}
                            {{ invoice.created_at | datetime }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" v-if="invoice.doc_type === 'credit_memo'">
                <div class="col">
                  <div class="form-group">
                    <label>{{ 'crediting_cause' | t }}</label>
                    <select class="form-control" v-model="invoice.crediting_cause">
                      <option v-for="cause in crediting_causes" :value="cause">{{ cause | t }}</option>
                    </select>
                  </div>
                </div>
                <div class="col">
                  <div class="form-group">
                    <label>{{ 'crediting_source' | t }}</label>
                    <select class="form-control" v-model="invoice.crediting_source">
                      <option v-for="source in billing_sources" :value="source">{{ source | t }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </template>
            <div class="form-group">
              <label>{{ 'account_date' | t }}</label>
              <div>
                <datetime-picker :dateonly="true" v-model="invoice.accounting_date"></datetime-picker>
              </div>
            </div>
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>{{ 'plan' | t }}</th>
                  <th>{{ 'product_identifier' | t }}</th>
                  <th>{{ 'description' | t }}</th>
                  <th>{{ 'unit_price' | t }}</th>
                  <th>{{ 'quantity' | t }}</th>
                  <th>{{ 'vat_percent' | t }}</th>
                  <th>{{ ' ' }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(line, i) in invoice.invoice_lines">
                  <td>
                    <select
                      class="form-control"
                      v-model="line.plan_id"
                      v-on:change="line.product_identification = find_plan(line.plan_id).billing_product_id"
                    >
                      <option :value="plan.id" v-for="plan in suitable_plans">{{ plan.name }}</option>
                    </select>
                  </td>
                  <td>
                    <input class="form-control" v-model="line.product_identification" />
                  </td>
                  <td>
                    <input class="form-control" v-model="line.description" />
                  </td>
                  <td>
                    <input class="form-control" v-model="line.unit_price" />
                  </td>
                  <td>
                    <input class="form-control" v-model="line.quantity" type="number" min="0.5" step="0.5" />
                  </td>
                  <td>
                    <input class="form-control-plaintext" :value="line.vat_percent" disabled="disabled" />
                  </td>
                  <td class="text-right">
                    <i
                      class="fa fa-trash clickable"
                      @click="invoice.invoice_lines.splice(i, 1)"
                      v-if="invoice.invoice_lines.length > 1"
                    ></i>
                  </td>
                </tr>
              </tbody>
            </table>
            <button class="btn btn-outline-primary" @click="add_line">{{ 'add_line' | t }}</button>
            <div class="mt-2">
              <strong>Total: {{ invoice_total }} {{ invoice.currency }}</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
  </with-actions>
</template>
<script>
import Api from '@/store/jsonapi';
import _ from 'lodash';
import Alerts from '@/utils/alerts.js';
import { CREDITING_CAUSES, BILLING_SOURCES } from '../../utils/billing';

export default {
  props: ['customer_id'],
  data: function () {
    return {
      customer: null,
      loading: false,
      invoice_search: '',
      loading_invoices: false,
      invoices: [],
      plans: [],
      invoice: {
        customer: { id: this.customer_id },
        doc_type: 'invoice',
        invoice: null,
        balance_account: true,
        accounting_date: null,
        invoice_lines: [
          {
            product_identification: null,
            unit_price: 0,
            quantity: 1,
            vat_percent: 0,
            plan_id: null
          }
        ]
      },
      crediting_causes: CREDITING_CAUSES,
      billing_sources: BILLING_SOURCES
    };
  },
  computed: {
    // Plans that start with "Crediting " are used if and only if creating credit memos (different account in economic)
    // Filter plans according to doc_type
    suitable_plans: function () {
      let is_invoice = this.invoice.doc_type == 'invoice';

      return _.filter(this.plans, (p) => is_invoice === !_.startsWith(p.name, 'Crediting '));
    },
    invoice_total: function () {
      let total = 0.0;
      let invoice_lines = this.invoice.invoice_lines;
      _.forEach(invoice_lines, (line) => {
        total += line.unit_price * line.quantity * (line.vat_percent / 100 + 1);
      });
      return total;
    },
    valid_invoice: function () {
      let valid = true;
      let invoice = this.invoice;
      if (this.loading || this.invoice_total <= 0) valid = false;
      _.forEach(invoice.invoice_lines, (il) => {
        if (!il.product_identification) valid = false;
      });
      return valid;
    }
  },
  watch: {
    'invoice.invoice': function () {
      if (this.invoice.invoice) {
        let original_date = this.invoice.invoice.accounting_date || this.invoice.invoice.created_at;

        // Clone accounting date
        if (original_date) {
          this.invoice.accounting_date = original_date;
        }

        // Clone invoice lines
        this.invoice.invoice_lines = _.map(_.cloneDeep(this.invoice.invoice.invoice_lines), (line) => {
          let picked_line = _.pick(line, [
            'description',
            'product_identification',
            'quantity',
            'vat_percent',
            'unit_price'
          ]);
          picked_line.description = 'Crediting: ' + line.description;
          return picked_line;
        });
      }
    }
  },
  methods: {
    find_plan(id) {
      return _.find(this.suitable_plans, (plan) => {
        return id == plan.id;
      });
    },
    async load_invoices() {
      let { data: invoices } = await Api.findAll('invoices', {
        filter: { customer_id: this.customer_id, doc_type: 'invoice' },
        sort: '-created_at'
      });
      this.invoices = invoices;
    },
    add_line() {
      this.invoice.invoice_lines.push({
        product_identification: this.plans[0].billing_product_id,
        unit_price: 0,
        quantity: 1,
        vat_percent: this.customer.vat_percent,
        plan_id: null
      });
    },
    async create() {
      if (this.invoice_total == 0) {
        Alerts.danger({
          title: 'Cannot create an invoice with total of zero',
          detail: ''
        });
        return;
      }
      if (this.invoice.doc_type == 'credit_memo' && !this.invoice.invoice) {
        Alerts.danger({
          title: 'Credit memos must be associated with an invoice',
          detail: ''
        });
        return;
      }
      await Api.create('invoices', this.invoice).then(() => {
        Alerts.success({ title: 'Document created', detail: '' });
        this.$router.push({
          name: 'customers_show',
          params: { customer_id: this.customer_id }
        });
      });
    }
  },
  mounted: async function () {
    let { data: customer } = await Api.find('customers', this.customer_id);
    this.customer = customer;
    this.invoice.currency = customer.currency;
    let { data: plans } = await Api.findAllPages('plans', {
      filter: { currency: customer.currency }
    });
    this.load_invoices();
    this.plans = plans;
    this.setBreadcrumbs([
      { to: { name: 'customers' }, text: 'Customers' },
      {
        to: { name: 'customers_show', customer_id: this.customer_id },
        text: this.customer.name
      },
      { to: {}, text: 'New invoice' }
    ]);
    _.forEach(this.invoice.invoice_lines, (line) => {
      line.vat_percent = customer.vat_percent;
      line.product_identification = this.plans[0].billing_product_id;
    });
  }
};
</script>

<style scoped></style>
